import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AccountService {

    constructor(private apiService: ApiService) { }

    getAccounts(params?: any): Observable<any> {
        return this.apiService.get('accounts', params);
    }

    getGroupedAccounts(params?: any): Observable<any> {
        return this.apiService.get('accounts/grouped', params);
    }

    getAccount(id: number): Observable<any> {
        return this.apiService.get(`accounts/${id}`);
    }

    getDropdowns(params?: any): Observable<any> {
        return this.apiService.get('accounts/dropdowns', params);
    }

    createAccount(data: any): Observable<any> {
        return this.apiService.post('accounts', data);
    }

    bulkCreate(data: any[]): Observable<any> {
        return this.apiService.post('accounts/bulk-store', data);
    }

    updateAccount(id: number, data: any): Observable<any> {
        return this.apiService.update(`accounts/${id}`, data);
    }

    deleteAccount(id: number): Observable<any> {
        return this.apiService.delete(`accounts/${id}`);
    }
    getUserAccounts(params?: any): Observable<any> {
        return this.apiService.get('user-accounts', params);
    }

    getJournalTransactions(params?: any): Observable<any> {
        return this.apiService.get('journal-trans', params);
    }

    getTrialBalance(params?: any): Observable<any> {
        return this.apiService.get('accounts/trial-balance', params);
    }

    getDaybookCashflow(params?: any): Observable<any> {
        return this.apiService.get('accounts/daybook/cashflow', params);
    }

    getProfitLoss(params?: any): Observable<any> {
        return this.apiService.get('accounts/profit-loss', params);
    }

    getBalanceSheet(params?: any): Observable<any> {
        return this.apiService.get('accounts/balance-sheet', params);
    }

    deleteJournal(id: number): Observable<any> {
        return this.apiService.delete(`journals/${id}`);
    }
}

